<template>
<div>   </div>
</template>

<script>
export default {
  created() {
    var that=this;
    var sdworkerID=this.$route.params.sdworkerId;
    console.log(this.$route.params.sdworkerId) ;
    this.$http.get('SDworker/SDWorkerLoginByID',{
      params:{
        sdworkerID:sdworkerID
      }
    }).then(res=>{
      // that.$router.push({
      //   name: "activity2023",
      //    params: { fromWechat: true },
      // });
      that.$router.push({
        name: "Index",
        params: { fromWechat: true },
      });
    });
    
  },
};
</script>

<style>
</style>